import styled from 'styled-components';

const ProfileCreateStyle = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	.form {
		max-width: 630px;
		flex-grow: 1;
		padding: 0;
		overflow-y: hidden;
		div.dynamic-form {
			height: calc(100% - var(--size));
			width: 100%;
			position: relative;
			form.main-form {
				height: calc(100% - 60px);
				width: 100%;
				overflow-y: auto;
				padding: var(--size);
			}
			.form-botom {
				position: absolute;
				bottom: 0;
				right: 0;
				left: 0;
				padding: 10px var(--size) 10px;
				background: #fff;
				text-align: right;
				border-top: 1px solid #e1e1e1;

				button{
					width: 200px;
				}
			}
		}
	}
	.ant-space {
		display: flex;
		justify-content: flex-start;
	}
	.half-inputs {
		.ant-space-item {
			width: calc(100% / 2);
		}
	}
	.ant-drawer-title {
		padding: 3px;
	}
	.ant-drawer-close {
		padding: 14px var(--size);
	}
	.ant-form.main-form {
		margin: var(--size) 0;
		.ant-form-item {
			margin-bottom: 8px;
		}
		label {
			font-weight: 500;
			color: rgba(0, 0, 0, 0.65);
		}
	}
	.forms {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		width: 350px;
		max-height: 100%;
		height: 100%;
		background: #fafafa;
		border-right: 1px solid rgba(0,0,0,0.1);
		overflow-y: auto;
		button {
			display: flex;
			flex-direction: row;
			justify-content: start;
			align-items: center;
			text-align: start;
			height: fit-content;
			padding: var(--size);
			white-space: pre-wrap;
			> span[role="img"]:nth-of-type(1) {
				font-size: var(--size-lg);
				color: rgba(0, 0, 0, 0.55);
				margin-right: var(--size);
			}
			> div {
				width: 100%;
				align-items: center;
				span {
					font-size: 14px;
				}
				> div {
					span:nth-of-type(1) {
						font-weight: 500;
						color: rgba(0, 0, 0, 0.65);
					}
					span:nth-of-type(2) {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.55);
					}
				}
			}
		}
		button.active {
			background: rgba(161, 194, 250, 0.16);
			border: none;
			> span[role="img"]:nth-of-type(1) {
				color: var(--mmt-primary-70);
			}
			> div {
				> div {
					span:nth-of-type(1) {
						color: var(--mmt-primary-70);
					}
				}
			}
		}
	}
`


export {
	ProfileCreateStyle
}
